<div class="row">
  <div class="col-lg-6 col-md-6 col-sm-6 margin-bottom-5 align-web">
    <label>{{invDetailText.orderNumberLbl?invDetailText.orderNumberLbl:invoiceDetail.orderNumberLbl}}: </label>
    <input type="text" kendoTextBox class="kendoInput float-right-pwa" value="{{invoicedetailsHeaderData?.orderNumber}}" disabled="disabled" style="margin-left:7px; width:11.9em;" />
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 margin-bottom-5">
    <label>{{invDetailText.relatedinvoiceLbl?invDetailText.relatedinvoiceLbl:invoiceDetail.relatedinvoiceLbl}}: </label>
    <kendo-dropdownlist [data]="invoiceNumberList" [(ngModel)]="invoiceNum" style="width: 11.9em;margin-left:7px"
                        textField="invoiceNumberWithSuffix" valueField="invoiceNumber" (valueChange)="invoiceNumberChange($event)"
                        class="kendoInput float-right-pwa" [loading]="loadingRelatedInvoices">
    </kendo-dropdownlist>
  </div>
</div>
<kendo-tabstrip  id="k-tabstrip" [tabPosition]="position" class="k-tabstrip invoice-detail-grid-class" (tabSelect)="onHeaderTabSelected($event)">
  <!--<kendo-tabstrip [scrollable]="true" [tabPosition]="position" class="k-tabstrip invoice-detail-grid-class" (tabSelect)="onHeaderTabSelected($event)">-->
  <kendo-tabstrip-tab title="{{invDetailText.invoiceHeaderLbl?invDetailText.invoiceHeaderLbl:invoiceDetail.invoiceHeaderLbl}}" [selected]="true">
    <ng-template kendoTabContent>
      <!--Need to bind text details dynamically-->
      <div class="header-details-section">
        <h4 class="fontSizeInPwa">{{invoicedetailsHeaderData?.jobName}}</h4>
        <!--<div class="row marginLeft-pwa">
        <div class="col-sm-4">
          <p>{{invDetailText.invoiceNumberLbl?invDetailText.invoiceNumberLbl:invoiceDetail.invoiceNumberLbl}}: {{invoicedetailsHeaderData?.invoiceNumber}}</p>
                <p>{{invDetailText.invoiceDateLbl?invDetailText.invoiceDateLbl:invoiceDetail.invoiceDateLbl}}: {{invoicedetailsHeaderData?.invoiceDateUIString}}</p>
          <p  style="line-height:1;">{{invDetailText.kdRefLbl?invDetailText.kdRefLbl:invoiceDetail.kdRefLbl}}: {{invoicedetailsHeaderData?.kdReferenceNumber}}</p>
        </div>-->
        <!--Need to bind for remaining-->
        <!--<div class="col-sm-4">
            <p>{{invDetailText.grossAmountLbl?invDetailText.grossAmountLbl:invoiceDetail.grossAmountLbl}}: {{invoicedetailsHeaderData?.grossAmount  |currency}}</p>
                <p>{{invDetailText.openAmountLbl?invDetailText.openAmountLbl:invoiceDetail.openAmountLbl}}: {{invoicedetailsHeaderData?.openAmount  |currency}}</p>
            <p style="line-height:1;">{{invDetailText.nonTaxableLbl?invDetailText.nonTaxableLbl:invoiceDetail.nonTaxableLbl}}: {{invoicedetailsHeaderData?.nonTaxableAmount  |currency}}</p>
          </div>
          <div class="col-sm-4">
            <p>{{invDetailText.taxableAmountLbl?invDetailText.taxableAmountLbl:invoiceDetail.taxableAmountLbl}}: {{invoicedetailsHeaderData?.taxableAmount  |currency}}</p>
                <p>{{invDetailText.taxLbl?invDetailText.taxLbl:invoiceDetail.taxLbl}}: {{invoicedetailsHeaderData?.tax  |currency}}</p>
          </div>
        </div>-->
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
{{invDetailText.invoiceNumberLbl?invDetailText.invoiceNumberLbl:invoiceDetail.invoiceNumberLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.invoiceNumber}}</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.grossAmountLbl?invDetailText.grossAmountLbl:invoiceDetail.grossAmountLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.grossAmount  |currency}}</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.taxableAmountLbl?invDetailText.taxableAmountLbl:invoiceDetail.taxableAmountLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.taxableAmount  |currency}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.invoiceDateLbl?invDetailText.invoiceDateLbl:invoiceDetail.invoiceDateLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.invoiceDateUIString}}</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.openAmountLbl?invDetailText.openAmountLbl:invoiceDetail.openAmountLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.openAmount  |currency}}</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.taxLbl?invDetailText.taxLbl:invoiceDetail.taxLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.tax  |currency}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.jobNameLbl?invDetailText.jobNameLbl:invoiceDetail.jobNameLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.jobName}}</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.nonTaxableLbl?invDetailText.nonTaxableLbl:invoiceDetail.nonTaxableLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.nonTaxableAmount  |currency}}</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 paddingZero">
            {{invDetailText.kdRefLbl?invDetailText.kdRefLbl:invoiceDetail.kdRefLbl}}:
            <span class="float-right-pwa"> {{invoicedetailsHeaderData?.kdReferenceNumber}}</span>
          </div>
        </div>
      </div>


    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{invDetailText.billingAddressLbl?invDetailText.billingAddressLbl:invoiceDetail.billingAddressLbl}}">
    <ng-template kendoTabContent>
      <div class="topGrid">
        <!--Need to bind text details dynamically-->
        <h4 class="fontSizeInPwa">{{invDetailText.billingAddressLbl?invDetailText.billingAddressLbl:invoiceDetail.billingAddressLbl}}</h4>
        <div class="row marginLeft-pwa">
          <div class="col-sm-4">
            <p>
              <!--2762 - ROYAL GLASS CO INC <br>
              3200 DE LA CRUZ BLVD. <br />
              SANTA CLARA, CA 95054-->
              {{billingAddress?.customerNumber}}-{{billingAddress?.customerName}}<br />
              {{billingAddress?.addressLine1}}{{billingAddress?.addressLine2}}<br />
              {{billingAddress?.city}},{{billingAddress?.state}} {{billingAddress?.zipCode}}
            </p><br />
          </div>
          <div class="col-sm-4">
          </div>
          <div class="col-sm-4">
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{invDetailText.shippingAddressLbl?invDetailText.shippingAddressLbl:invoiceDetail.shippingAddressLbl}}">
    <ng-template kendoTabContent>
      <div class="topGrid">
        <!--Need to bind text details dynamically-->
        <h4 class="fontSizeInPwa">{{invDetailText.shippingAddressLbl?invDetailText.shippingAddressLbl:invoiceDetail.shippingAddressLbl}}</h4>
        <div class="row marginLeft-pwa">
          <div class="col-sm-4">
            <p>
              <!--2762 - ROYAL GLASS CO INC <br>
              3200 DE LA CRUZ BLVD. <br />
              SANTA CLARA, CA 95054-->
              <!--Uncomment below lines once ship to id is received-->
              {{shippingAddress?.customerNumber}}-{{shippingAddress?.customerName}}<br />
              {{shippingAddress?.addressLine1}}{{shippingAddress?.addressLine2}}<br />
              {{shippingAddress?.city}},{{shippingAddress?.state}} {{shippingAddress?.zipCode}}
            </p><br />

          </div>
          <div class="col-sm-4">
          </div>
          <div class="col-sm-4">
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>

<br />
<kendo-tabstrip [tabPosition]="position1" (tabSelect)="onTabSelect($event)" class="k-tabstrip invoice-detail-grid-class">
  <kendo-tabstrip-tab [title]="'Invoice Details'" [selected]="true">
    <ng-template kendoTabContent>
      <br>
      <!--[height]="470"-->
      <kendo-grid [data]="invoiceDetailsGridData"
                  class="invoiceDetailsGridCls"
                  [sortable]="true"
                  [selectable]="false"
                  [navigable]="true"
                  [filterable]="true"
                  [groupable]="false"
                  [reorderable]="true"
                  [resizable]="false"
                  [sort]="invoiceDetailsGridstate.sort"
                  [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }"
                  [pageSize]="invoiceDetailsGridstate.take"
                  [skip]="invoiceDetailsGridstate.skip"
                  [columnMenu]="{  filter: false, sort: false }"
                  (sort)="invoiceDetailsGridSortChange($event)"
                  (pageChange)="invoiceDetailsGridPageChange($event)"
                  (dataStateChange)="invoiceDetailsDataStateChange($event)"
                  (columnReorder)="onReorder($event)"
                  (columnVisibilityChange)="onVisibilityChange($event)"
                  [filter]="invoiceDetailsGridstate.filter"
                  [loading]="invoiceDetailsLoading">
        <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-button-display btn-web">
            <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
              {{invDetailText.exportToExcelLbl?invDetailText.exportToExcelLbl:invoiceDetail.exportToExcelLbl}}
              <kendo-loader *ngIf="loadingExcel"></kendo-loader>
            </button>
            <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generatePDF()">
              {{invDetailText.exportToPdfLbl?invDetailText.exportToPdfLbl:invoiceDetail.exportToPdfLbl}}
              <kendo-loader *ngIf="loadingPDF"></kendo-loader>
            </button>
          </div>
          <input placeholder="Search in all columns..."
                 kendoTextBox
                 (input)="onFilterInvoiceDetail($event.target.value)" class="pwaInvoiceDetailSearch" />

        </ng-template>

        <kendo-grid-column media="(max-width: 1024px)" title="Invoice Details">
          <ng-template kendoGridCellTemplate let-dataItem>

            <div class="row mb-3">
              <div class="col-12 paddingZero job-name">
                <span class="txt-bold">{{dataItem.itemNumber}} - {{dataItem.itemDescription}}</span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.orderDateLbl ? this.invDetailText.orderDateLbl : this.invoiceDetail.orderDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.orderDateUIString}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.orderTypeLbl ? this.invDetailText.orderTypeLbl : this.invoiceDetail.orderTypeLbl}}:</span> <span class="float-right-pwa"> {{dataItem.orderType}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.qtyLbl ? this.invDetailText.qtyLbl : this.invoiceDetail.qtyLbl}}:</span> <span class="float-right-pwa"> {{dataItem.quantity}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.uomLbl ? this.invDetailText.uomLbl : this.invoiceDetail.uomLbl}}:</span><span class="float-right-pwa"> {{dataItem.uom}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.unitPriceLbl ? this.invDetailText.unitPriceLbl : this.invoiceDetail.unitPriceLbl}}:</span><span class="float-right-pwa"> {{dataItem.unitPrice}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.extendedPriceLbl ? this.invDetailText.extendedPriceLbl : this.invoiceDetail.extendedPriceLbl}}:</span><span class="float-right-pwa"> {{dataItem.extendedPrice}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.shipFromLbl ? this.invDetailText.shipFromLbl : this.invoiceDetail.shipFromLbl}}:</span><span class="float-right-pwa"> {{dataItem.shipFrom}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold">{{this.invDetailText.statusLbl ? this.invDetailText.statusLbl : this.invoiceDetail.statusLbl}}:</span><span class="float-right-pwa"> {{dataItem.status}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero"></div>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column *ngFor="let col of gridSettings.columnsConfig"
                           [field]="col.field"
                           [title]="col.title"
                           [width]="col._width"
                           [filter]="col.filter"
                           [filterable]="col.filterable"
                           [hidden]="col.hidden"
                           [format]="col.format" media="(min-width: 1025px)">
          <ng-template *ngIf="position != 'left'">
          </ng-template>
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'unitPrice'">
            {{ (dataItem.invoiceLineDetail=='N' && dataItem.itemNumber != 'FRT')? "" :  dataItem?.unitPrice |currency}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'extendedPrice'">
            {{(dataItem.invoiceLineDetail=='N' && dataItem.itemNumber != 'FRT')? "" : dataItem?.extendedPrice |currency}}
          </ng-template>
          <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'orderDateAsDate'">
        <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="filter"
                                   field="orderDateAsDate">
        </app-grid-daterange-filter>
      </ng-template>-->
        </kendo-grid-column>
        <!--<kendo-grid-column field="orderNumber"
                       title="{{invoiceDetailsGridColumnLbl.orderNumber}}"
                       [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="line"
                       title="{{invoiceDetailsGridColumnLbl.line}}"
                       [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="orderDateAsDate" filter="date" format="{0:d}"
                       title="{{invoiceDetailsGridColumnLbl.orderDate}}" [width]="220">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="filter"
                                   field="orderDateAsDate">
        </app-grid-daterange-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderType"
                       title="{{invoiceDetailsGridColumnLbl.orderType}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="quantity"
                       title="{{invoiceDetailsGridColumnLbl.qty}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="uom"
                       title="{{invoiceDetailsGridColumnLbl.uom}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="itemNumber"
                       title="{{invoiceDetailsGridColumnLbl.item}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="description"
                       title="{{invoiceDetailsGridColumnLbl.description}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="unitPrice"
                       title="{{invoiceDetailsGridColumnLbl.unitPrice}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="extendedPrice"
                       title="{{invoiceDetailsGridColumnLbl.extendedPrice}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="shipFrom"
                       title="{{invoiceDetailsGridColumnLbl.shipFrom}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="status"
                       title="{{invoiceDetailsGridColumnLbl.status}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>-->
        <ng-template kendoGridNoRecordsTemplate>
        </ng-template>
        <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>-->

      </kendo-grid>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
